export default __webpack_public_path__ + "static/media/WelcomeScreenHeroImageV3.bcd963b9.png";